/** @format */
import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Hidden from '@material-ui/core/Hidden';
// material-ui icons
import Menu from '@material-ui/icons/Menu';
import MoreVert from '@material-ui/icons/MoreVert';
import ViewList from '@material-ui/icons/ViewList';
// core components
import AdminNavbarLinks from './AdminNavbarLinksExt';
import Button from 'components/CustomButtons/Button.jsx';
import adminNavbarStyle from 'assets/jss/material-dashboard-pro-react/components/adminNavbarStyle.jsx';
// search module
import I18n from '../Translate/I18n';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import {NavLink} from 'react-router-dom';
import ListItemText from '@material-ui/core/ListItemText';
import i18n from '../../core/i18n';
import {Auth} from '../../modules/auth/Auth';
import COLORS from '../../assets/themes/OPL/colors';
import ReactDOM from "react-dom";

function AdminNavbar({...props}) {
    const ref = useRef();
    const {classes, color, rtlActive, brandText,scrollPosition} = props;
    const appBarClasses = cx({
        [' ' + classes[color]]: color,
    });
    const sidebarMinimize =
        classes.sidebarMinimize +
        ' ' +
        cx({
            [classes.sidebarMinimizeRTL]: rtlActive,
        });
    const itemText =
        classes.itemText +
        ' ' +
        cx({
            [classes.itemTextMini]: props.miniActive,
            [classes.itemTextMiniRTL]: false,
            [classes.itemTextRTL]: false,
        });

    let topNavbarClientNavStyle = {};
    if (!scrollPosition) {
        topNavbarClientNavStyle = {display: 'none'};
    }

    return (
        <AppBar className={classes.appBar + appBarClasses}>
            <Toolbar className={classes.container}>
                <div className={classes.flex}>
                    {/* Here we create navbar brand, based on route name */}
                    <Button href="#" className={classes.title} color="transparent"
                            style={{position: 'sticky', left: 15}}>
                        <I18n trans={brandText}/>
                    </Button>
                </div>
                <div style={{position: 'absolute', right: 0}}>
                    <div style={{position: 'absolute', left: 0, top: 0}}>
                        <Hidden smDown implementation="css">
                            <div style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'baseline', position: 'fixed', right: 30, top: 5, ...topNavbarClientNavStyle
                            }}>
                                <AdminNavbarLinks rtlActive={rtlActive}/>
                                <span><I18n trans={'auth:sidebar.welcome'}/> {` ${Auth.getUserName()}`}</span>
                            </div>
                        </Hidden>
                    </div>
                </div>
                <Hidden mdUp implementation="css">
                    <Button
                        className={classes.appResponsive}
                        color="transparent"
                        justIcon
                        aria-label="open drawer"
                        onClick={props.handleDrawerToggle}
                    >
                        <Menu/>
                    </Button>
                </Hidden>
            </Toolbar>
        </AppBar>
    );
}

AdminNavbar.propTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.oneOf(['primary', 'info', 'success', 'warning', 'danger']),
    rtlActive: PropTypes.bool,
    brandText: PropTypes.string,
};
export default withStyles(adminNavbarStyle)(AdminNavbar);